import Vue from "vue";
import Router from "vue-router";
import store from "@/store/store";
import meetnetRoutes from "./meetnet";

Vue.use(Router);

let router = new Router({
  // mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login/:nextUrl?",
      name: "loginView",
      component: () => import("@/views/loginView"),
    },
    { path: "/redirect" },
    {
      path: "/",
      name: "appView",
      component: () => import("@/views/appView"),
      meta: { requiresAuth: true },
    },
    {
      path: "/map?scenarioId",
      name: "mapView",
      component: () => import("@/views/mapView"),
      meta: { requiresAuth: true },
    },
    // dynamic segments start with a colon
    {
      path: "/map/:id",
      component: () => import("@/views/mapView"),
      meta: { requiresAuth: true },
    },
    // meetnet
    ...meetnetRoutes,
    // End meetnet
    {
      path: "/config/:id",
      component: () => import("@/views/configView"),
      meta: { requiresAuth: true },
      props: true,
      children: [
        {
          name: "projectsettings",
          path: "", //should load default page but does nog work
          props: true,
          component: () => import("@/components/configuration/projectSettings"),
        },
        {
          name: "sharePage",
          path: "sharePage",
          props: true,
          component: () => import("@/components/configuration/sharePage"),
        },
        {
          name: "projectcontent",
          path: "content",
          props: true,
          component: () => import("@/components/configuration/projectContent"),
        },
      ],
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("@/views/about"),
    },
    { path: "*", redirect: "/" },
  ],
  // mode: 'abstract' THIS MAKES IT POSSIBLE TO HIDE THE URL ID BUT BEHAVIOUR IS UNPREDICTABLE
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) {
      window.replace(
        `${process.env.VUE_APP_CAS_URL}/login?service=${window.location.href}`
      );
      // next({ name: "loginView", params: { nextUrl: to.fullPath } });
    } else {
      let user = JSON.parse(localStorage.getItem("user"));
      if (to.matched.some((record) => record.meta.isAdmin)) {
        if (user.is_admin) {
          next();
        } else {
          next({ name: "appView" });
        }
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

export default router;
